import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useProductAttributeStore } from "../../../hooks/useProductAttributeStore";
import { useSpecificAttributeStore } from "../../../hooks/useSpecificAttributeStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { useTypeAttributeStore } from "../../../hooks/useTypeAttributeStore";

type Values = {
    id: number,
    code: string,
    name: string,
    description: string,
    idtype: number,
    status: string,
}

const states = [
    {name: 'Activo', value: '1'},
    {name: 'Desactivo', value: '0'},
]

const columns = [
    // { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'checkbox', field: 'checkbox', label: 'checkbox', align:'center' },
];


const columnsParent = [
    { type: 'text', field: 'parent_name', label: 'Nombre', align:'center' }
]

const columnsChild= [
    { type: 'text', field: 'child_name', label: 'Nombre', align:'center' }
]

export const ProductAttributeModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, attributeSelected, listAttribute, clearState } = props;

    const { action, createproductAttribute, editproductAttribute } = useProductAttributeStore();
    const { getSpecificAttributesByCompany } = useSpecificAttributeStore();
    const { gettypeAttributeByCompany} = useTypeAttributeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [specificAttributes, setSpecificAttributes] = useState<any>([]);
    const [typeAttributes, setTypeAttributes] = useState<any>([]);
    const [selected, setSelected] = useState<any>([]);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);
    const [data, setData] = useState<Values>({
        id: attributeSelected ? attributeSelected.id :'',
        code: attributeSelected ? attributeSelected.code :'',
        name: attributeSelected ? attributeSelected.name :'',
        description: attributeSelected ? attributeSelected.description :'',
        idtype: attributeSelected ? attributeSelected.idtype :'',
        status: attributeSelected ? attributeSelected.status :'1',
    });

    useEffect(() => {
        if(attributeSelected && specificAttributes && !searchTimeout){
            const idspecificattributes = attributeSelected && attributeSelected.idspecificattributes
                ? JSON.parse(attributeSelected.idspecificattributes)
                : [];
            const attributesSelected = specificAttributes.filter(attribute => idspecificattributes.includes(attribute.id));
            setSelected(attributesSelected || []);
        }
    },[attributeSelected, specificAttributes, !searchTimeout])

    useEffect(() => {
        getgetSpecificAttributesByCompanyApi()
        gettypeAttributeByCompanyAPI();

    },[])

    const gettypeAttributeByCompanyAPI = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await gettypeAttributeByCompany(search);
            if(!response){
                setTypeAttributes([]);
                setLoadingdata(false);
                return false;
            }else{
                setTypeAttributes(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getgetSpecificAttributesByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getSpecificAttributesByCompany(search);
            if(!response){
                setSpecificAttributes([]);
                setLoadingdata(false);
                return false;
            }else{
                setSpecificAttributes(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = specificAttributes.map((n) => n);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };
    const onCheckbox = (row) => {
        const selectedIndex = selected.findIndex(selectedRow => selectedRow.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };
    const isSelected = (row) => {
        return selected.some(item => item.id === row.id);
    };

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getgetSpecificAttributesByCompanyApi(term)}, 1000)
        )
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.code) errors.code = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        // if(!values.description) errors.description = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idspecificattributes = selected.map(use => use.id);

        const formData = {
            ...values,
            idspecificattributes: JSON.stringify(idspecificattributes)
        }

        if(attributeSelected){
            const response:any = await editproductAttribute(attributeSelected.id, formData);
            if(response){
                listAttribute && listAttribute();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createproductAttribute(formData);
            if(response){
                listAttribute && listAttribute();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }
    console.log(attributeSelected)

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: open ? 'slide-in 0.3s ease-out' : 'slide-out 0.3s ease-in', maxHeight: '100%', height: '100vh'}}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar atributo de producto' : (action == 'add' ? 'Nuevo atributo de producto' : 'Detalle del atributo')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Código:</FormLabel>
                                            <TextField
                                            id="code"
                                            type="text" 
                                            name="code"
                                            fullWidth
                                            size="small"
                                            value={values.code}
                                            onChange={handleChange}
                                            error={errors.code && touched.code ? true : false}
                                            helperText={errors.code && touched.code ? errors.code : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Nombre del atributo:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        {
                                            !attributeSelected && (
                                                <Grid item xs={12} md={4}>
                                                    <FormLabel>Estado:</FormLabel>
                                                    <Select
                                                        id="status"
                                                        value={values.status}
                                                        size="small"
                                                        onChange={(event) => { 
                                                            setFieldValue("status", event.target.value);
                                                        }}
                                                        error={ errors.status && touched.status ? true : false }
                                                        fullWidth
                                                    >
                                                        {
                                                            states.map((state, i) => {
                                                                return <MenuItem key={i} value={state.value}>{state.name}</MenuItem>;
                                                            })
                                                        }
                                                    </Select>
                                                </Grid>
                                            )
                                        }
                                        <Grid item xs={12} md={8}>
                                            <FormLabel>Descripción:</FormLabel>
                                            <TextField
                                                id="description"
                                                type="text" 
                                                name="description"
                                                fullWidth
                                                size="small"
                                                value={values.description}
                                                onChange={handleChange}
                                                error={errors.description && touched.description ? true : false}
                                                helperText={errors.description && touched.description ? errors.description : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <FormLabel>Tipo de Atributo:</FormLabel>
                                            <Select
                                                id="idtype"
                                                name="idtype"
                                                value={values.idtype}
                                                size="small"
                                                onChange={(event) => {
                                                    setFieldValue("idtype", event.target.value);
                                                }}
                                                error={errors.idtype && touched.idtype ? true : false}
                                                fullWidth
                                            >
                                                {typeAttributes.map((type, i) => (
                                                    <MenuItem key={i} value={type.id}>
                                                        {type.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                titlelabel={'Atributos padres'}
                                                columns={columnsParent} 
                                                loading={loadingdata} 
                                                hasOptions
                                                rows={attributeSelected.parent_attributes || []}
                                                onRowClick={() => {}}
                                                RowsPerPage={5}
                                                dense
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                titlelabel={'Atributos hijos'}
                                                columns={columnsChild} 
                                                loading={loadingdata} 
                                                hasOptions
                                                rows={attributeSelected.child_attributes || []}
                                                onRowClick={() => {}}
                                                RowsPerPage={5}
                                                dense
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                titlelabel={'usos específicos'}
                                                columns={columns} 
                                                loading={loadingdata} 
                                                hasOptions
                                                rows={specificAttributes || []}
                                                onRowClick={() => {}}
                                                onCheckbox={onCheckbox}
                                                isSelected={isSelected}
                                                selectAll={handleSelectAllClick}
                                                onSearch={onSearch}
                                                RowsPerPage={5}
                                                dense
                                            />
                                        </Grid>
                                        
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}